
export enum EOfferTyp {
  WebshopOfferNumber = 0,
  IntegraOfferNumber = 1,
  IntegraDid = 2
}
